import React from "react"
import { IconCircleInfoOutline18 as InfoIcon } from "nucleo-ui-outline-18"

import { Tooltip } from "@productlane/ui"

export const ImportanceTooltip = React.memo(() => {
	return (
		<Tooltip
			label={
				<div>
					The priority score sums up all <br></br>insights that are connected
					with this feature: <br /> <br />
					Upvote or no importance = 1 point
					<br />
					Medium = 2 points
					<br />
					Important = 3 points
					<br />
					Critical = 4 points
				</div>
			}
		>
			<InfoIcon className="h-3 w-3 flex-none text-tertiary hover:text-primary" />
		</Tooltip>
	)
})
